import React, { useState, useRef, useEffect } from 'react';

import { Box, useTheme } from '@chakra-ui/react';

import { ViewStar } from 'assets/assetsV1/iconComponents';

export const ResultStarRating = ({ precision = 1, maxRating = 5, rating = 0 }) => {
  const [activeStar, setActiveStar] = useState(rating);
  const ratingContainerRef = useRef(null);
  const { colors } = useTheme();

  useEffect(() => {
    setActiveStar(rating);
  }, [rating]);

  return (
    <Box>
      <Box
        sx={{
          display: 'inline-flex',
          gap: '6px',
        }}
        ref={ratingContainerRef}
      >
        {[...new Array(maxRating)].map((arr, index) => {
          const activeState = activeStar;
          const showEmptyIcon = activeState === -1 || activeState < index + 1;
          return showEmptyIcon ? (
            <ViewStar boxSize="25px" color={colors.neutral.CFD7DF} />
          ) : (
            <ViewStar boxSize="25px" color={colors.functional['44812F']} />
          );
        })}
      </Box>
    </Box>
  );
};
